import styled from 'styled-components';

export const Container = styled.div`
  .subtitle {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
  }

  hr {
    border: 1px solid #ced4da;
  }
`;
